module.exports = __webpack_public_path__ + "img/zhang.172933a8.png";